export default __webpack_public_path__ + "static/media/juego28_conexito.5bc3e3d1.png";